import { useQuery } from 'react-query';

import type { ProceduralTimelineEvent } from '../../../../backend/src/matter/procedural-timeline/procedural-timeline-event.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetProceduralTimelineEvents = (matterId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<ProceduralTimelineEvent[], Error>(
    [QueryEntity.ProceduralTimelineEvents, { matterId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/events`, fetchConfigGET);
      if (!res.ok) throw new Error('Failed to fetch procedural timeline events');
      return res.json();
    },
    { enabled: !!matterId, refetchOnWindowFocus: false },
  );
};
